export default __webpack_public_path__ + "static/media/sponsered-img.1f1e49e7.png";